/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.
*/

(function() {
  // Add custom code below this line

  function fixRestockBadges() {
    document.querySelectorAll('[samitalock-handle]').forEach(function(card) {
      if (card.dataset.restockChecked) return;
      card.dataset.restockChecked = 'true';

      var handle = card.getAttribute('samitalock-handle');
      if (!handle) return;

      fetch('/products/' + handle + '.js')
        .then(function(res) { return res.json(); })
        .then(function(product) {
          var tags = (product.tags || []).map(function(t) { return t.toUpperCase(); });
          if (!tags.includes('RESTOCK')) return;

          var badge = card.querySelector('#availablefromGS, [data-eta-rewritten]');
          if (!badge) return;

          badge.textContent = 'Ready to Ship \u2014 More in the Works!';
          badge.style.cssText = 'display:block!important;margin-top:8px!important;padding:8px 10px!important;font-size:14px!important;font-weight:600!important;color:#d82e92!important;background-color:#ffffff!important;border:2px solid #d82e92!important;text-align:center!important;border-radius:3px!important;line-height:1.5!important;width:100%!important;box-sizing:border-box!important;';
        })
        .catch(function() {});
    });
  }

  window.addEventListener('load', function() {
    setTimeout(fixRestockBadges, 800);
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
